/**
 * 標高の符号を復元する。Base64 → 下位バイトが先の符号つき 16 ビット整数 → 0.1m 単位。
 * 結果は 32 ビット浮動小数で持つ（計算結果をサンプルと一致させるため）。
 */
export function decodeElevations(b64: string): Float32Array {
  const bin = atob(b64);
  const n = bin.length >> 1;
  const out = new Float32Array(n);
  for (let i = 0; i < n; i++) {
    let v = bin.charCodeAt(2 * i) | (bin.charCodeAt(2 * i + 1) << 8);
    if (v > 32767) v -= 65536;
    out[i] = v / 10;
  }
  return out;
}

/**
 * 線の符号を復元する。先頭 2 つが最初の点（1000 倍の整数）、以降は前の点との差。
 * 返す点は [経度, 緯度]（度）。
 */
export function decodeLine(a: readonly number[]): [number, number][] {
  if (a.length < 2 || a.length % 2 !== 0) throw new Error('線の符号の長さが不正');
  let x = a[0]!;
  let y = a[1]!;
  const out: [number, number][] = [[x / 1000, y / 1000]];
  for (let i = 2; i < a.length; i += 2) {
    x += a[i]!;
    y += a[i + 1]!;
    out.push([x / 1000, y / 1000]);
  }
  return out;
}
